import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { search } = additionalData;

  return (
    <div className="bg-white flex flex-col gap-16 items-start justify-start relative w-full not-first:pt-8 not-last:pb-8 not-last:border-b not-last:border-gray-950/10">
      <div className="flex flex-col gap-3 items-start justify-start relative w-full">
        <div className="flex flex-col items-start justify-start not-italic relative w-full">
          <div className="flex-col justify-center min-w-full overflow-ellipsis overflow-hidden relative text-gray-900 text-base font-normal">
            <p>{Craft.t(search, 'Loading...')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
